import { render, staticRenderFns } from "./ftp-actions-upload.vue?vue&type=template&id=895aa15e&scoped=true&"
import script from "./ftp-actions-upload.vue?vue&type=script&lang=js&"
export * from "./ftp-actions-upload.vue?vue&type=script&lang=js&"
import style0 from "./ftp-actions-upload.vue?vue&type=style&index=0&id=895aa15e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895aa15e",
  null
  
)

export default component.exports